import React from 'react';
import styled from 'styled-components';

import { GridContainer, ByLeanloop, HeaderCap } from '@agilytics/components';
import masthead from './masthead.svg';

const StyledHeader = styled.header`
  background: ${({
    theme: {
      colors: { accent },
    },
  }) => accent};
`;

const ParentBrandContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const StyledHeaderCap = styled.svg`
  margin-top: -5px;
  width: 100%;
`;

export default function Header(props) {
  return (
    <>
      <StyledHeader>
        <GridContainer>
          <ParentBrandContainer>
            <ByLeanloop />
          </ParentBrandContainer>
          <img src={masthead} alt="agilytics - data-driven forecasts for agile teams." />
        </GridContainer>
      </StyledHeader>
      <StyledHeaderCap preserveAspectRatio="none" width="1024px" height="105px" viewBox="0 0 1024 105">
        <HeaderCap />
      </StyledHeaderCap>
    </>
  );
}
